import 'reflect-metadata';
import {jsonObject, jsonMember, TypedJSON} from 'typedjson';

@jsonObject
export class JobOutputMessage {

  public static get Serializer(): TypedJSON<JobOutputMessage> {
    if (!JobOutputMessage.serializer) {
      JobOutputMessage.serializer = new TypedJSON(JobOutputMessage);
    }

    return JobOutputMessage.serializer;
  }

  private static serializer: TypedJSON<JobOutputMessage> | undefined;

  @jsonMember
  public Service!: string;

  @jsonMember
  public Job!: string;

  @jsonMember
  public Id!: number;

  @jsonMember
  public Timestamp!: number;

  @jsonMember
  public Stream!: number;

  @jsonMember({deserializer: (m) => atob(m)})
  public Message!: string;
}
